<template>
	<div>
		<offer-edit-specific-quality-parameter
			v-for="parameter in productQualityParameters"
			:key="'EDIT_PARAMETER_' + parameter.id"
			:form="form"
			:parameter="parameter"
		>
		</offer-edit-specific-quality-parameter>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			required: true,
		},
		suppressGmp: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			form: this.value,
		};
	},
	computed: {
		productQualityParameters() {
			let parameters = this.$cropOptions.getProductQualityParameters(
				this.form.product.type,
				this.form.product.grade
			);

			// Bei Landwirt-Beteiligung GMP+/FSA nicht anbieten.
			if (this.suppressGmp) {
				return parameters.filter(
					(parameter) => parameter.id !== "gmp_certified"
				);
			}

			return parameters;
		},
	},
};
</script>
